import Box from "@mui/joy/Box";
import IconButton from "@mui/joy/IconButton";
import Drawer from "@mui/joy/Drawer";
import Input from "@mui/joy/Input";
import List from "@mui/joy/List";
import ListItemButton from "@mui/joy/ListItemButton";
import Typography from "@mui/joy/Typography";
import ModalClose from "@mui/joy/ModalClose";
import { useState } from "react";
import { FaBars } from "react-icons/fa";
import { Link, useLocation } from "react-router";
import Menu from "./Menus";
import { MdArrowForwardIos } from "react-icons/md";

const MobileSidebar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation(); // current path
  const [OpenIndex, setOpenIndex] = useState(Menu.map((_, i) => i));

  const toggleSubMenu = (index) => {
    if (OpenIndex.includes(index)) {
      setOpenIndex(OpenIndex.filter((i) => i !== index));
    } else {
      setOpenIndex([...OpenIndex, index]);
    }
  };

  return (
    <>
      <IconButton
        variant="outlined"
        color="neutral"
        onClick={() => setOpen(true)}
      >
        <FaBars />
      </IconButton>
      <Drawer
        size="sm"
        anchor="right"
        open={open}
        onClose={() => setOpen(false)}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            ml: "auto",
            mt: 1,
            mr: 2,
          }}
        >
          <Typography
            component="label"
            htmlFor="close-icon"
            sx={{ fontSize: "sm", fontWeight: "lg", cursor: "pointer" }}
          ></Typography>
          <ModalClose id="close-icon" sx={{ position: "initial" }} />
        </Box>

        <div className="flex-1 overflow-y-auto px-3 scrollbar-hide pt-3">
          {Menu.map((item, index) => {
            const isActive = item.path && location.pathname === item.path;

            return (
              <div key={index} className="mb-3">
                <Link to={`${item.path ? item.path : "#"}`}>
                  <div
                    onClick={() => toggleSubMenu(index)}
                    className={`flex justify-between items-center border py-2 px-2 rounded-lg select-none cursor-pointer ${
                      isActive ? "bg-blue-100" : "bg-white"
                    }`}
                  >
                    <div className="flex items-center justify-start gap-x-2 text-black/80">
                      <div>{item.icon}</div>
                      <div>
                        <p>{item.name}</p>
                      </div>
                    </div>
                    <div>
                      {item.children && (
                        <div className="text-black/80">
                          <MdArrowForwardIos
                            className={
                              OpenIndex.includes(index)
                                ? "rotate-90 transform transition-all"
                                : ""
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </Link>

                {OpenIndex.includes(index) && item.children && (
                  <div>
                    {item.children.map((child, childIndex) => {
                      const isChildActive =
                        child.path && location.pathname === child.path;

                      return (
                        <div
                          key={childIndex}
                          className={`relative py-2 pl-10 pr-4 mt-1 select-none cursor-pointer ${
                            isChildActive ? "bg-blue-100 rounded-lg" : ""
                          }`}
                        >
                          <Link to={child.path}>
                            <div className="flex items-center justify-start gap-x-2 text-black/80">
                              <div>
                                <p className="text-sm">{child.name}</p>
                              </div>
                              <div className="h-10 absolute top-0 left-5 border-gray-100 border-r border"></div>
                              <div className="rotate-90 h-4 absolute top-0 transform translate-y-1/2 left-7 border-gray-100 border-r border"></div>
                            </div>
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Drawer>
    </>
  );
};

export default MobileSidebar;
